import React from 'react'

export const ShopAndRuntimeConfigContext = React.createContext({
  publicConfig: {},
  pageProperties: {}
})

export const withShopAndRuntimeConfigContextDecorator = configs => story => {
  return (
    <ShopAndRuntimeConfigContext.Provider value={configs}>
      {story()}
    </ShopAndRuntimeConfigContext.Provider>
  )
}
